// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentTransactionDetailController = function ($scope, $routeParams, $window, PaymentTransaction, Order, PlanVariant, Plan, PaymentRefund) {
    
    let invoiceReferenceCodeRedirectUrls = Object.freeze({
        "Invoice" : "invoices",
        "InvoiceDraft" : "invoice-drafts"
    });
    
    function setHrefForInvoiceReferenceCode () {
        $scope.invoiceReferenceCodeHref = "";
        
        if ($scope.transaction.InvoiceId){
            $scope.invoiceReferenceCodeHref = `#/${invoiceReferenceCodeRedirectUrls.Invoice}/${$scope.transaction.InvoiceId}`;
        }
        else if ($scope.transaction.InvoiceDraftId){
            $scope.invoiceReferenceCodeHref = `#/${invoiceReferenceCodeRedirectUrls.InvoiceDraft}/${$scope.transaction.InvoiceDraftId}`;
        }
    }
    
    $scope.transaction = PaymentTransaction.get({ paymentTransactionId: $routeParams.paymentTransactionId }, function (data) {
        if (data.Status.Status == 'Failed' && data.Trigger == 'Signup')
            $scope.order = Order.get({ orderId: data.OrderId }, function (data) {
                PlanVariant.get({ id: data.PlanVariantId }, function (data) {
                    $scope.plan = Plan.get({ id: data.PlanId });
                });
            });
        
        setHrefForInvoiceReferenceCode();
    });
    
    $scope.order = null;
    $scope.refunds = PaymentRefund.query({ search: $routeParams.paymentTransactionId });

    $scope.statusClass = function (status) {
        switch (status) {
            case 'Succeeded':
            case 'PreliminarySucceeded':
                return "label-success";
            case 'Failed':
            case 'Chargeback':
                return "label-important";
            default:
                return '';
        }
    };
    
    $scope.back = function () {
        $window.history.back();
    }
};
PaymentTransactionDetailController.$inject = ['$scope', '$routeParams', '$window', 'PaymentTransaction', 'Order', 'PlanVariant', 'Plan', 'PaymentRefund'];
